import { render } from "./AdminPlans.vue?vue&type=template&id=6ca52f8e&scoped=true"
import script from "./AdminPlans.vue?vue&type=script&lang=js"
export * from "./AdminPlans.vue?vue&type=script&lang=js"

import "./AdminPlans.vue?vue&type=style&index=0&id=6ca52f8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ca52f8e"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QSkeleton,QToggle,QTooltip,QDialog,QCard,QCardSection,QSpace,QBtn,QInput,QCardActions,QSpinner});qInstall(script, 'directives', {ClosePopup});
